import { Flex, Heading, useColorMode } from "@chakra-ui/react";
import { GroupMenuProps } from "../../../types/sidebar-v2.type";
import Menu from "./Menu";
import SubMenu from "./SubMenu";
import sidebarV2Store from "../../../stores/sidebar-v2.store";
import teamStore from "../../../stores/team.store";

interface GroupMenuComponentProps {
  groupMenu: GroupMenuProps
}

export default function GroupMenu(props: GroupMenuComponentProps) {
  const { groupMenu } = props

  const { reveal } = sidebarV2Store()
  const { team } = teamStore()
  const { colorMode } = useColorMode()

  const getGroupMenuColor = (): string => {
    if (colorMode === 'dark') return 'neutral.90'

    switch (team?.theme_object.code) {
      case 'Yellow-vis':
        return 'white'
      case 'Grey-vis':
        return 'black'
      default:
        return 'neutral.90'
    }
  }

  const groupMenuColor = getGroupMenuColor()

  return (
    <Flex direction='column' gap='4px'>
      <Heading 
        size='chakra_label_large' 
        color={groupMenuColor}
        display={reveal ? 'block' : 'none'}
      >{groupMenu.label}</Heading>
      {groupMenu.menus.map((menu, menuIndex) => {
        if (menu.type === 'standalone') return <Menu key={menuIndex} standaloneMenu={menu} />
        else if (menu.type === 'parent') return <SubMenu key={menuIndex} parentMenu={menu} />
      })}
    </Flex>
  )
}
